import React from 'react';
import { UniverseModuleType } from 'src/domains/common/universes.type';
import { features } from './bresbet.features';
import { themeColors } from './bresbet.config';
import { BresbetLogotype } from './bresbet.logotype';
import { BresBetLogo } from 'src/layouts/LoginPage/logos/BresBetLogo';
import BresBetLoginImage from 'src/layouts/LoginPage/loginBgImages/BresBetLoginImage.jpg';
import { BresbetBrandIconWrapper, CompliancePopupLogo } from './bresbet.style';
import { LoginImageWrapper } from 'src/layouts/LoginPage/LoginImage.style';

export const universeModule: UniverseModuleType = {
    themeColors,
    features,
    title: 'BresBet Backoffice',
    urls: {
        website: 'https://bresbet.com/',
        backoffice: 'https://backoffice.bresbet.com/',
    },
    BrandIcon: () => <BresbetBrandIconWrapper />,
    Logotype: () => <BresbetLogotype />,
    LogotypeLoginPage: () => <BresBetLogo />,
    compliancePopupLogo: () => <CompliancePopupLogo />,
    loginImageContainer: () => <LoginImageWrapper imgSrc={BresBetLoginImage} />,
};
